export enum WREvents {
  PointSelected = 'pointSelected',
  SitesUpdated = 'sitesUpdated',
  VisualSelected = 'visualSelected',
  VisualSaved = 'visualSaved',
  SiteUpdated = 'siteUpdated',
  ScreenPositionsUpdated = 'screenPositionsUpdated',
  ModelDeploy = 'modelDeploy',
  VisualRemoved = "visualRemoved",
  VisualLoaded = "visualLoaded",
  SiteActivated = "siteActivated",
  SiteDeactivated = "siteDeactivated",
  EditFloor = "editFloor",
  EditPolygonDone = "editPolygonDone",
  ScenarioSelected = "scenarioSelected",
  AgentsUpdated = "agentsUpdated",
  CameraSelected = "cameraSelected",
  CameraOverlayUpdate = "cameraOverlayUpdate"
}
